export interface ErgebnisState {
    ortsueblicheMieteProQM: string,
    ortsueblicheMiete: string,
    ortsueblicheMieteSpanneUntenProQM: string,
    ortsueblicheMieteSpanneUnten: string,
    ortsueblicheMieteSpanneObenProQM: string,
    ortsueblicheMieteSpanneOben: string,
    ortsueblicheMieteSpanneBegruendeteAbweichungenProQM: string,
    ortsueblicheMieteSpanneBegruendeteAbweichungen: string,
    schwankungObenProQm: string,
    schwankungUntenProQm: string,
    begruendeteAbweichungenProQmTrue: string,
    begruendeteAbweichungenTooHigh: boolean,
    begruendeteAbweichungenTooLow: boolean
}

export default {
    namespaced: true,
    state: {
        ortsueblicheMieteProQM: '',
        ortsueblicheMiete: '',
        ortsueblicheMieteSpanneUntenProQM: '',
        ortsueblicheMieteSpanneUnten: '',
        ortsueblicheMieteSpanneObenProQM: '',
        ortsueblicheMieteSpanneOben: '',
        ortsueblicheMieteSpanneBegruendeteAbweichungenProQM: '',
        ortsueblicheMieteSpanneBegruendeteAbweichungen: '',
        schwankungObenProQm: '',
        schwankungUntenProQm: '',
        begruendeteAbweichungenProQmTrue: '',
        begruendeteAbweichungenTooHigh: false,
        begruendeteAbweichungenTooLow: false
    } as ErgebnisState,
    getters: {
    },
    mutations: {
        SET_MIETEPROQM(state:ErgebnisState, ortsueblicheMieteProQM:string) {
            state.ortsueblicheMieteProQM = ortsueblicheMieteProQM
        },
        SET_MIETE(state:ErgebnisState, ortsueblicheMiete:string) {
            state.ortsueblicheMiete = ortsueblicheMiete
        },
        SET_MIETESPANNEUNTENPROQM(state:ErgebnisState, ortsueblicheMieteSpanneUntenProQM:string) {
            state.ortsueblicheMieteSpanneUntenProQM = ortsueblicheMieteSpanneUntenProQM
        },
        SET_MIETESPANNEUNTEN(state:ErgebnisState, ortsueblicheMieteSpanneUnten:string) {
            state.ortsueblicheMieteSpanneUnten = ortsueblicheMieteSpanneUnten
        },
        SET_MIETESPANNEOBENPROQM(state:ErgebnisState, ortsueblicheMieteSpanneObenProQM:string) {
            state.ortsueblicheMieteSpanneObenProQM = ortsueblicheMieteSpanneObenProQM
        },
        SET_MIETESPANNEOBEN(state:ErgebnisState, ortsueblicheMieteSpanneOben:string) {
            state.ortsueblicheMieteSpanneOben = ortsueblicheMieteSpanneOben
        },
        SET_MIETESPANNEBEGRUENDETEABWEICHUNGENPROQM(state:ErgebnisState, ortsueblicheMieteSpanneBegruendeteAbweichungenProQM:string) {
            state.ortsueblicheMieteSpanneBegruendeteAbweichungenProQM = ortsueblicheMieteSpanneBegruendeteAbweichungenProQM
        },
        SET_MIETESPANNEBEGRUENDETEABWEICHUNGEN(state:ErgebnisState, ortsueblicheMieteSpanneBegruendeteAbweichungen:string) {
            state.ortsueblicheMieteSpanneBegruendeteAbweichungen = ortsueblicheMieteSpanneBegruendeteAbweichungen
        },
        SET_SCHWANKUNGOBENPROQM(state:ErgebnisState, schwankungObenProQm:string) {
            state.schwankungObenProQm = schwankungObenProQm
        },
        SET_SCHWANKUNGUNTENPROQM(state:ErgebnisState, schwankungUntenProQm:string) {
            state.schwankungUntenProQm = schwankungUntenProQm
        },
        SET_BEGRUENDETEABWEICHUNGENPROQMTRUE(state:ErgebnisState, begruendeteAbweichungenProQmTrue:string) {
            state.begruendeteAbweichungenProQmTrue = begruendeteAbweichungenProQmTrue
        },
        SET_BEGRUENDETEABWEICHUNGENTOOHIGH(state:ErgebnisState, begruendeteAbweichungenTooHigh:boolean) {
            state.begruendeteAbweichungenTooHigh = begruendeteAbweichungenTooHigh
        },
        SET_BEGRUENDETEABWEICHUNGENTOOLOW(state:ErgebnisState, begruendeteAbweichungenTooLow:boolean) {
            state.begruendeteAbweichungenTooLow = begruendeteAbweichungenTooLow
        }
    },
    actions: {
        RESET_ERGEBNIS({ commit }: { commit: Function }){
            commit('SET_MIETE', '')
            commit('SET_MIETEPROQM', '')
            commit('SET_MIETESPANNEOBEN', '')
            commit('SET_MIETESPANNEOBENPROQM', '')
            commit('SET_MIETESPANNEUNTEN', '')
            commit('SET_MIETESPANNEUNTENPROQM', '')
            commit('SET_MIETESPANNEBEGRUENDETEABWEICHUNGEN', '')
            commit('SET_MIETESPANNEBEGRUENDETEABWEICHUNGENPROQM', '')
            commit('SET_SCHWANKUNGOBENPROQM', '')
            commit('SET_SCHWANKUNGUNTENPROQM', '')
            commit('SET_BEGRUENDETEABWEICHUNGENPROQMTRUE', '')
            commit('SET_BEGRUENDETEABWEICHUNGENTOOHIGH', false)
            commit('SET_BEGRUENDETEABWEICHUNGENTOOLOW', false)
        },
        SET_ERGEBNIS({ commit }: { commit: Function}, payload: { ergebnis:ErgebnisState }) {
            commit('SET_MIETE', payload.ergebnis.ortsueblicheMiete)
            commit('SET_MIETEPROQM', payload.ergebnis.ortsueblicheMieteProQM)
            commit('SET_MIETESPANNEOBEN', payload.ergebnis.ortsueblicheMieteSpanneOben)
            commit('SET_MIETESPANNEOBENPROQM', payload.ergebnis.ortsueblicheMieteSpanneObenProQM)
            commit('SET_MIETESPANNEUNTEN', payload.ergebnis.ortsueblicheMieteSpanneUnten)
            commit('SET_MIETESPANNEUNTENPROQM', payload.ergebnis.ortsueblicheMieteSpanneUntenProQM)
            commit('SET_MIETESPANNEBEGRUENDETEABWEICHUNGEN', payload.ergebnis.ortsueblicheMieteSpanneBegruendeteAbweichungen)
            commit('SET_MIETESPANNEBEGRUENDETEABWEICHUNGENPROQM', payload.ergebnis.ortsueblicheMieteSpanneBegruendeteAbweichungenProQM)
            commit('SET_SCHWANKUNGOBENPROQM', payload.ergebnis.schwankungObenProQm)
            commit('SET_SCHWANKUNGUNTENPROQM', payload.ergebnis.schwankungUntenProQm)
            commit('SET_BEGRUENDETEABWEICHUNGENPROQMTRUE', payload.ergebnis.begruendeteAbweichungenProQmTrue)
            commit('SET_BEGRUENDETEABWEICHUNGENTOOHIGH', payload.ergebnis.begruendeteAbweichungenTooHigh)
            commit('SET_BEGRUENDETEABWEICHUNGENTOOLOW', payload.ergebnis.begruendeteAbweichungenTooLow)
        }
    }
}